import client from '../client';
import type { StoreTeamUser, AddUserInput, UpdateRoleInput } from '../../types/user';
import type { ApiResponse } from '../../types/api';

interface UserListParams {
  sort?: 'asc' | 'desc';
  startDate?: string;
  endDate?: string;
}

export const usersApi = {
  list: async (storeId: string, params?: UserListParams) => {
    const res = await client.get<ApiResponse<{ users: StoreTeamUser[] }>>(
      `/dashboard/${storeId}/users`,
      { params },
    );
    return res.data.data!;
  },

  add: async (storeId: string, data: AddUserInput) => {
    // Backend uses raw res.json({ status }) instead of apiSuccess wrapper
    const res = await client.post<{ status: string }>(
      `/dashboard/${storeId}/users`,
      data,
    );
    const d = (res.data as any)?.data ?? res.data;
    return d as { status: string };
  },

  updateRole: async (storeId: string, userId: string, data: UpdateRoleInput) => {
    await client.patch(`/dashboard/${storeId}/users/${userId}/role`, data);
  },

  delete: async (storeId: string, userId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/users/${userId}`);
  },

  getRole: async (storeId: string, roleId: string) => {
    const res = await client.get<ApiResponse<{ role: { _id: string; role: string; permissions: string[]; storeId: string } }>>(
      `/dashboard/${storeId}/users/roles/${roleId}`,
    );
    return res.data.data!;
  },

  acceptInvitation: async (storeId: string, inviteId: string) => {
    await client.post(`/dashboard/${storeId}/users/invitations/${inviteId}/accept`);
  },

  declineInvitation: async (storeId: string, inviteId: string) => {
    await client.post(`/dashboard/${storeId}/users/invitations/${inviteId}/decline`);
  },
};
